(function () {
  if (window.lucide) {
    lucide.createIcons();
  }

  var mobileMenuBtn = document.querySelector("[data-mobile-menu-btn]");
  var mobileNav = document.querySelector("[data-mobile-nav]");
  if (mobileMenuBtn && mobileNav) {
    mobileMenuBtn.addEventListener("click", function () {
      var open = mobileNav.classList.toggle("is-open");
      mobileMenuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  var faqButtons = document.querySelectorAll("[data-faq-toggle]");
  faqButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var item = button.closest("[data-faq-item]");
      if (item) {
        item.classList.toggle("is-open");
      }
    });
  });

  var thumbs = document.querySelectorAll("[data-thumb]");
  var mainImage = document.querySelector("[data-gallery-main]");
  if (thumbs.length && mainImage) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        thumbs.forEach(function (other) {
          other.classList.remove("is-active");
        });
        thumb.classList.add("is-active");
        mainImage.src = thumb.dataset.thumb;
        mainImage.alt = thumb.dataset.thumbAlt || mainImage.alt;
      });
    });
  }

  var quantityOut = document.querySelector("[data-quantity]");
  if (quantityOut) {
    var minus = document.querySelector("[data-quantity-minus]");
    var plus = document.querySelector("[data-quantity-plus]");
    minus.addEventListener("click", function () {
      var value = Math.max(1, parseInt(quantityOut.value || "1", 10) - 1);
      quantityOut.value = value;
    });
    plus.addEventListener("click", function () {
      var value = Math.min(99, parseInt(quantityOut.value || "1", 10) + 1);
      quantityOut.value = value;
    });
  }

  var variantSelect = document.querySelector('select[name="id"]');
  var variantIdInput = document.querySelector("[data-variant-id]");
  if (variantSelect && variantIdInput) {
    variantSelect.addEventListener("change", function () {
      variantIdInput.value = variantSelect.value;
    });
  }

  var filterBtn = document.querySelector("[data-filter-toggle]");
  var filterPanel = document.querySelector("[data-filter-panel]");
  if (filterBtn && filterPanel) {
    filterBtn.addEventListener("click", function () {
      filterPanel.classList.toggle("is-open");
    });
  }

  function showToast(message) {
    var existing = document.querySelector(".toast");
    if (!existing) {
      existing = document.createElement("div");
      existing.className = "toast";
      document.body.appendChild(existing);
    }
    var icon = document.createElement("i");
    icon.dataset.lucide = "check-circle";
    existing.textContent = "";
    existing.appendChild(icon);
    existing.appendChild(document.createTextNode(message));
    if (window.lucide) {
      lucide.createIcons({ attrs: { class: ["toast-icon"] } });
    }
    existing.classList.add("is-visible");
    clearTimeout(existing._timer);
    existing._timer = setTimeout(function () {
      existing.classList.remove("is-visible");
    }, 2600);
  }

  var addButtons = document.querySelectorAll("[data-add-to-cart]");
  addButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      showToast("Added to cart");
    });
  });

  var forms = document.querySelectorAll("[data-newsletter-form]");
  forms.forEach(function (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      showToast("Thanks! Check your inbox for 10% off");
      form.reset();
    });
  });
})();
